/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationLogoModel } from '../../models/organization-logo-model';

export interface ConsumerFhirIdLogoIdGet$Params {
  fhirId: string;
  id: string;
}

export function consumerFhirIdLogoIdGet(http: HttpClient, rootUrl: string, params: ConsumerFhirIdLogoIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationLogoModel>> {
  const rb = new RequestBuilder(rootUrl, consumerFhirIdLogoIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationLogoModel>;
    })
  );
}

consumerFhirIdLogoIdGet.PATH = '/Consumer/{fhirId}/Logo/{id}';
